import Admin from './components/admin/Admin';
import AdminRoutes from './components/admin/AdminRoutes';
import GetApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import Home from './components/Home';
import Parking from './components/Parking';
import RequestQuote from './components/RequestQuote';
import Services from './components/Services';
import TrackShipment from './components/TrackShipment';

const GetAppRoutes = (setAuthenticated: (a: boolean) => void, isAuthenticated: boolean, isAppLoading: boolean) => [
  {
    index: true,
    requireAuth: false,
    element: <Home />
  },
  {
    path: '/services',
    requireAuth: false,
    element: <Services />
  },
  {
    path: '/request-quote',
    requireAuth: false,
    element: <RequestQuote />
  },
  {
    path: '/track-shipment',
    requireAuth: false,
    element: <TrackShipment />
  },
  {
    path: '/parking',
    requireAuth: false,
    element: <Parking />
  },
  {
    path: '/admin',
    requireAuth: true,
    element: <Admin />
  },
  ...GetApiAuthorizationRoutes(setAuthenticated),
  ...AdminRoutes
];

export default GetAppRoutes;
